<div class="wrapper">
	<div class="left-slot">
		<ion-icon (click)="backClick.emit()" src="../../../assets/toolbar/back.svg"></ion-icon>
	</div>
	<div class="info-section">
		<ion-img class="logo" src="../../../assets/topgolf/header_logo.svg"></ion-img>
		<!-- <div class="section-info">
            <div class="name">
                <h3>
                    {{ venue.name }}
                </h3>
                <div *ngIf="order?.preorder?.type">
                    {{ 'preorder_type.' + order?.preorder?.type | translate }}
                </div>
            </div>
            <div class="info">
                <p>{{ venue.street }} {{ venue.number }}, {{ venue.city.de }}</p>
                <ion-icon (click)="backClick.emit()" src="../../../assets/toolbar/edit.svg"></ion-icon>
            </div>
        </div> -->
	</div>
	<div class="right-clot">
		<app-burger-btn></app-burger-btn>
	</div>
</div>
